/**
 * @desc 新品下单-详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductOrderResponseDto>;
export function request(npono: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productOrder/details/${npono}`, {
      method: "GET",

      ...options,
    }),
  );
}
